// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Fade transition */\n.idleFade-enter-active[data-v-4b4c7c82],\n.idleFade-leave-active[data-v-4b4c7c82] {\n  -webkit-transition: opacity 0.5s ease;\n  transition: opacity 0.5s ease;\n}\n.idleFade-enter[data-v-4b4c7c82],\n.idleFade-leave-to[data-v-4b4c7c82] {\n  opacity: 0;\n}", ""]);
// Exports
module.exports = exports;
